import {Injectable} from '@angular/core';
@Injectable() 
export class Utils {
    rand() {
        return Math.floor(Math.random() * (9999999999 - 1000000000) + 1000000000);
    }
    linear(timeFraction) {
        return timeFraction;
    }
    easeInOutCubic(timeFraction) {
        return timeFraction<.5 ? 4*timeFraction*timeFraction*timeFraction : (timeFraction-1)*(2*timeFraction-2)*(2*timeFraction-2)+1;
    }
    /* taken from https://javascript.info/js-animation */
    animate({timing = 'linear', draw, duration = 200}) {
        const timingFn = this[timing];

        const start = performance.now();
      
        window.requestAnimationFrame(function tick(time) {
            let timeFraction = (time - start) / duration;
            if (timeFraction > 1) timeFraction = 1;
            if( timeFraction < 0 ) timeFraction = 0;

            const progress = timingFn(timeFraction);
      
            draw(progress);
      
            if (timeFraction < 1) {
                window.requestAnimationFrame(tick);
            }
      
        });
    }
    trackByIndex(index) {
        /*
        * why is this function here?
        * issue: binding to an array directly like `value=slideshow.assignment.ads[i]` causes a repainting issue
        * https://github.com/angular/angular.js/issues/13327#issuecomment-157844505 for more information
        * fix: https://stackoverflow.com/questions/42322968/angular2-dynamic-input-field-lose-focus-when-input-changes and https://stackoverflow.com/questions/52469372/angular-binding-to-string-array-at-index
        */
        return index;
    }
    convertDateToUtc(date) {
        date = typeof date === 'string' ? new Date(date) : date;
        return new Date(date.getTime() + date.getTimezoneOffset() * 60 * 1000);
    }
    convertUtcDateToLocal(date) {
        date = typeof date === 'string' ? new Date(date) : date;
        return new Date(date.getTime() - date.getTimezoneOffset() * 60 * 1000);
    }
    padZero(num) {
        return ('0' + num).slice(-2);
    }
    getFormattedDate(date) {
        return date.getFullYear() + '-' + [
            (date.getMonth()+1),
            date.getDate()
        ]
        .map(num => this.padZero(num))
        .join('-') + ' ' + [
            date.getHours(),
            date.getMinutes(),
            date.getSeconds()
        ]
        .map(num => this.padZero(num)).join(':');
    }
}